export * from './get-source-from-image-content';
